const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: '5px',
        border: '2px solid #ccc',
        boxShadow: null,//state.isFocused ? '0 0 0 2px #3699FF' : null,
        ':hover': {
            // backgroundColor: 'lightgray',
            // color: 'black',
            border: '2px solid #ccc',
        },
    }),
    option: (provided, state) => ({
        ...provided,
        //  backgroundColor: state.isFocused ? 'var(--lightestGrey)' : null,
        // color: state.isFocused ? 'white' : null,
        backgroundColor: state.isSelected ? 'var(--white)' : 'var(--white)',
        color: state.isSelected ? 'var(--skyDark)' : 'var(--black)',
        ':hover': {
            backgroundColor: 'var(--white)',
            color: 'var(--skyDark)',
            // border: '2px solid #ccc',
        },
    }),
}

export {
    customStyles
}